import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';

@Injectable({
  providedIn: 'root'
})
export class StaffApiService {

  constructor(private http: HttpClient) { }
  getGemsData(id: any) {
    return lastValueFrom(this.http.get(`staff/getStaffOrgData/${id}`))
  }
  getById(id: any) {
    return lastValueFrom(this.http.get(`staff/getById/${id}`))
  }
  getDetails(id: any) {
    return lastValueFrom(this.http.get(`staff/getDetail/${id}`))
  }
  save(data: any) {
    return lastValueFrom(this.http.post(`staff/save`, data))
  }
  getList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`staff/getList/${lasyP}`))
  }
  getListOnlyDeleted(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`staff/getListOnlyDeleted/${lasyP}`))
  }
  relive(id, data: any) {
    return lastValueFrom(this.http.post(`staff/relive/${id}`, data))
  }
  makeActive(id, data: any) {
    return lastValueFrom(this.http.post(`staff/makeActive/${id}`, data))
  }
  // search(terms: any,wh:any) {
  //   const lasyP = isEmptyObj(wh) ? '' : '/' + JSON.stringify(wh);
  //   return lastValueFrom(this.http.get(`staff/search/${terms}/${lasyP}`))
  // }
  search(terms: any, wh: any = []) {
    const lasyP = JSON.stringify(wh);
    return lastValueFrom(this.http.get(`staff/search/${terms}/${lasyP}`))
  }
}
